import { render, staticRenderFns } from "./HistoryDeta.vue?vue&type=template&id=698b014a&scoped=true&"
import script from "./HistoryDeta.vue?vue&type=script&lang=js&"
export * from "./HistoryDeta.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDeta.vue?vue&type=style&index=0&id=698b014a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b014a",
  null
  
)

export default component.exports